export const en = {
  change_item: 'Change',
  declDays: ['day', 'days', 'days'],
  error: 'Error',
  apply: 'Apply',
  search: 'Search',
  fill_all: 'Fill in all the fields',
  fields_config_error: '',
  checkout_title: 'Place order',
  receiver_country: 'Country of receipt',
  delivery_city: 'Delivery city',
  delivery_city1: 'Delivery city',
  choose_delivery_city_title: 'Delivery city',
  choose_delivery_city_desc:
    'Choose your delivery city and we will offer the best and most convenient options for you.',
  choose_button: 'Choose',
  back_to_cart_button: 'Back to cart',
  switch_city_button: 'Change city',
  cancel: 'Cancel',
  from: 'from',
  close: 'Close',
  create: 'Save',
  switch_city_from: 'Change city',
  switch_city_to: 'change city to',
  switch_city_description:
    'In the event of a city change, delivery methods and options will be changed.',
  save: 'Save Changes',
  real_data: 'Specify real data',
  real_data_description: 'When issuing an order, you may be asked for an id',
  checkout_current_wallet: 'Current bonus account',
  coral_wallet_not_use: "Don't use points",
  checkout_enter_coralwallet: 'Enter amount',
  checkout_use_coralwallet: 'Use points',
  checkout_edit_coralwallet: 'Edit',
  coral_wallet_balance: 'balance',
  coral_wallet_can_cover_all:
    'Have your entire order paid with your Coral Wallet balance!',
  coral_wallet_apply_full: 'Apply 100% discount below.',
  coral_wallet_can_cover_part:
    'You can use {amount} from your Coral Wallet for this order',
  coral_wallet_pay_rest_another:
    'Apply discount below and pay the remaining amount using another payment method.',
  coral_wallet_another_amount: 'I want to use another amount',
  coral_wallet_choose_amount:
    'What amount would you like to use from your Coral Wallet as a discount for this order?',
  coral_wallet_enter_amount: 'Enter the amount',
  coral_wallet_apply: 'Apply discount',
  coral_wallet_remove: 'Remove discount',
  coral_wallet_applied: '{amount} discount has been applied to your order.',
  coral_wallet_rest_to_pay:
    'You still need to pay {rest} using one of the payment options below.',
  coral_wallet_fully_paid:
    'Congratulations, your order is fully paid using your Coral Wallet balance.',
  payment_methods_subtitle: 'Select your preferred payment method',
  checkout_de_phone_tooltip:
    "For express delivery, provide a number corresponding to the recipient's country.",
  checkout_pick_payment_notify: 'Select a payment method to place your order',
  error_checkout_empty_basket: 'Empty basket',
  fill_courier_address_field: 'Please enter the street and house number',
  fill_that_field: 'Please complete this field.',
  enter_first_and_last_name: 'Please enter your first and last name',
  hidden_fields_error: 'Field not filled in',
  wrong_field: 'The field is filled incorrectly.',
  wrong_email: 'Invalid email',
  wrong_phone: 'Wrong phone',
  wrong_phone_with_country_code:
    'The first digits of the phone number must not contain a country code',
  number_must_start_from_2: 'The phone number must begin with the number 2',
  number_must_start_from_7: 'The phone number must begin with the number 7',
  change_country:
    'To change the country, you will be returned to the shopping cart. The contents of the order and the amount may change.',
  nds: 'VAT is included in the price',
  use_coins: 'Use Coral Wallet',
  can_use_coins: 'To pay for the order, you can use up to',
  dont_use_coins: 'Do not use Coral Wallet',
  total_coins: 'Now in your account',
  wallet_description: 'Use Coral Wallet to pay for orders',
  reciever_fio: 'First and Last Name',
  reciever_phone: 'Phone number',
  phone_country_only:
    'Now you can use the phone number of the country where you place the order.',
  reciever_email: 'Email',
  reciever_name: 'First Name',
  reciever_family: 'Last Name',
  'profile-second-name': 'Middle Name',
  legal: 'Entity',
  company_name: 'Additional Information',
  receiver_title: 'Recipient',
  new_receiver: 'New recipient',
  edit_receiver: 'Edit',
  choose_delivery_type: 'Choose receiving method',
  free_shipping: 'Free',
  delivery_type_title: 'Delivery method',
  new_delivery_address: 'New address',
  free_delivery: 'Yay! Free delivery!',
  edit_delivery_address: 'Change address',
  my_addresses: 'My addresses',
  all_addresses: 'All addresses',
  no_delivery_types: 'There are no shipping methods available for this address',
  comfortable_day: 'On a day convenient for you',
  work_hours: 'Opening hours',
  goto: 'Next',
  no_addresses: 'No addresses available',
  remove_profiles: 'Delete all profiles',
  confirm_remove_profiles: 'Delete all profiles?',
  confirm_remove_that_profile: 'Delete this profile?',
  delivery_services: 'Delivery options',
  enter_destination_address: 'Delivery address',
  kyiv_outside: '',
  msk_courier_1day_restriction:
    'Express delivery is carried out only within the Moscow Ring Road',
  choose_pickpoint: 'Select pickup point',
  checkout_title_pickpoints_PL: 'Wybierz punkt odbioru',
  map_template: 'Map',
  list_template: 'List',
  selected_pickpoint_title: 'Selected',
  selected_pickpoint_worktime: 'Schedule',
  selected_pickpoint_note: 'How to get there',
  selected_pickpoint_price: 'Delivery cost',
  selected_pickpoint_contacts: 'Contacts',
  selected_pickpoint_contacts_phone: 'Phone number',
  selected_pickpoint_contacts_email: 'Email',
  selected_pickpoint_change_button: 'Choose another',
  selected_pickpoint_site: 'Website',
  cant_change_to_pickpoint: '',
  delivery_address_label: 'Street, house number',
  delivery_city_label: 'City*',
  new_delivery_back: 'Return',
  new_delivery_accept: 'Confirm',
  payment_method_title: 'Payment method',
  checkout_cw7date_notify:
    'We remind you that bonuses for the previous month are not awarded on the 7th day. Final information on the bonus account balance will appear after the completion of accruals on the 8th.',
  payment_methods: 'Payment Methods',
  choose_payment_method: 'Payment method',
  coral_wallet_title: 'Use Coral Wallet',
  payment_title: '',
  payment_text: '',
  payment_notification_de:
    'It is no longer possible to pay directly through VIsa. To pay with a Visa card, use PayPal Plus.',
  address_info_fields_korpus: 'bld.',
  address_info_fields_apartment: 'apt.',
  address_info_fields_entrance: 'entrance',
  address_info_fields_intercom: '',
  address_faktura_text: 'Show faktura',
  faktura_label: 'Faktura',
  provide_receiver_info: 'Recipient data',
  address_comment: 'Additional',
  basket_title: 'Your order',
  basket_change: 'Change',
  basket_order_weight: 'Order weight',
  basket_order_weight_item: 'gr',
  basket_order_items: 'Products',
  basket_bonus: 'Used from Coral Wallet',
  basket_delivery: 'Delivery',
  basket_pickpoint: 'Pick point',
  basket_total: 'Total:',
  basket_cashback: 'Volume points',
  basket_free: 'free',
  profiles_address_search_text:
    "Use the search, and we'll suggest options, or enter an address on the map.",
  profiles_necessary_field: 'Required fields',
  find_address_map: 'Find an address on the map',
  approximate_delivery_time: 'Estimated delivery time',
  profiles_no_data: 'No data',
  profiles_edit_step: 'Edit profile',
  profiles_pickpoints_delivery_title: 'Pick-up points',
  profiles_courier_delivery_title: 'Courier delivery',
  ORDER_DELIVERY_POST: 'Mail Delivery',
  profiles_edit_button: 'Edit',
  profiles_details_button: 'View details',
  profiles_delete_button: 'Delete profile',
  profiles_delete_modal_title: 'Delete profile?',
  profiles_modal_button_keep: 'Keep',
  profiles_modal_button_delete: 'Delete',
  profiles_input_mask: 'Enter an address',
  profiles_pickpoints_working_hours: 'Opening hours',
  profiles_details_close_button: 'Close',
  profiles_delivery_details: 'Delivery details',
  ORDER_PROFILES: 'My Profiles',
  basket_usa_order_info:
    'Orders over $200 are shipped with signature request. Fedex will attempt 3 deliveries. Should you find this inconvenient, please contact us to make alternative arrangements when placing the order.',
  ORDER_PROMO_CODE_BUTTON: 'I have a promo code',
  ORDER_PROMO_CODE_DISCOUNT: 'Discount by promo code',
  membership_title: 'Club number of your consultant',
  membership_yes: 'Yes',
  membership_no: 'No',
  membership_placeholder: "Consultant's Coral ID",
  additional_info_block_title: 'Order comments',
  additional_info_block_comment_placeholder: 'Your comment',
  additional_info_block_need_to_contact:
    'Contact me to clarify the details of the order or payment',
  additional_info_block_need_to_contact_phone: 'By phone',
  additional_info_block_need_to_contact_sms: 'By SMS',
  additional_info_block_need_to_contact_messenger: 'By messenger',
  additional_info_block_receive_emails:
    'I want to receive emails about discounts and promotions',
  additional_info_block_accept_terms_intro: 'I agree with',
  additional_info_block_accept_terms_link: 'Terms of order and delivery',
  additional_info_small:
    'By clicking &laquo;Proceed to payment&raquo;, you agree to the terms of use of the CoralClub service. Detailed terms of delivery can be found on the page delivery and payment',
  additional_button: 'Proceed to payment',
  additional_button_place_order: 'Place order',
  additional_info_term1_text: null,
  additional_info_term1_text_ru:
    "By placing an order, you agree to the <a href='/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href=/faq/terms/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.    ",
  additional_info_term1_text_us:
    "By placing an order, you agree to the <a href='/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='/faq/offer/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.    ",
  additional_info_term1_text_ua:
    "By placing an order, you agree to the <a href='/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href=/faq/offer/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.    ",
  additional_info_term1_text_ro:
    "By placing an order, you agree to the <a href='/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='/faq/offer/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.    ",
  additional_info_term1_text_pl:
    "By placing an order, you agree to the <a href='/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='/faq/offer/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.    ",
  additional_info_term1_text_hu: '',
  additional_info_term1_text_cz:
    "By placing an order, you agree to the <a href='/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='/faq/terms/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.    ",
  additional_info_term1_text_sk:
    "By placing an order, you agree to the <a href='/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='/faq/offer/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.    ",
  additional_info_term1_text_bg:
    "By placing an order, you agree to the <a href='/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='/faq/terms/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.",
  additional_info_term1_text_ee:
    "By placing an order, you agree to the <a href='/faq/privacy/'  class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='/faq/terms/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.    ",
  additional_info_term1_text_lt:
    "By placing an order, you agree to the <a href='/faq/privacy/'  class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='/faq/terms/'  class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.     ",
  additional_info_term1_text_lv:
    "By placing an order, you agree to the <a href='https://lv.coral.club/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='https://lv.coral.club/faq/offer/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.",
  additional_info_term1_text_de:
    "By placing an order, you agree to the <a href='/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='/faq/terms/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.<br><br><a href='/images/documents/AGB.pdf' class='text-accentColor font-medium' target='_blank'>Here</a> You can view our Terms of Sale and download them.",
  additional_info_term1_text_it:
    "By placing an order, you agree to the <a href='https://it.coral.club/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='https://it.coral.club/faq/terms/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.",
  additional_info_term1_text_es:
    "By placing an order, you agree to the <a href='/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='/faq/offer/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.",
  additional_info_term1_text_fr:
    "By placing an order, you agree to the <a href='https://fr.coral.club/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='https://fr.coral.club/faq/terms/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.",
  additional_info_term1_text_ka:
    "By placing an order, you agree to the <a href='ge.coral.club/faq/privacy/'>Privacy Policy</a> and accept the <a href='ge.coral.club/faq/offer/'>Terms and Conditions</a>.",
  additional_info_term1_text_il:
    "By placing an order, you agree to the <a href='/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='/faq/terms/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.",
  additional_info_term1_text_kz: '',
  additional_info_term1_text_be:
    "By placing an order, you agree to the <a href='https://be.coral.club/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='https://be.coral.club/faq/terms/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.",
  additional_info_term1_text_at:
    "By placing an order, you agree to the <a href='https://at.coral.club/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='https://at.coral.club/faq/terms/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.",
  additional_info_term1_text_gr:
    "By placing an order, you agree to the <a href='/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='/faq/offer/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.    ",
  additional_info_term1_text_gb:
    "By placing an order, you agree to the <a href='https://gb.coral.club/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='https://gb.coral.club/faq/terms/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.",
  additional_info_term1_text_dk:
    "By placing an order, you agree to the <a href='https://dk.coral.club/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='https://dk.coral.club/faq/terms/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.",
  additional_info_term1_text_ie:
    "By placing an order, you agree to the <a href='https://ie.coral.club/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='https://ie.coral.club/faq/terms/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.",
  additional_info_term1_text_cy:
    "By placing an order, you agree to the <a href='https://cy.coral.club/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='https://cy.coral.club/faq/terms/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.",
  additional_info_term1_text_lu:
    "By placing an order, you agree to the <a href='lu.coral.club/faq/privacy/'>Privacy Policy</a> and accept the <a href='lu.coral.club/faq/offer/'>Terms and Conditions</a>.",
  additional_info_term1_text_mt:
    "By placing an order, you agree to the <a href='https://mt.coral.club/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='https://mt.coral.club/faq/terms/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.",
  additional_info_term1_text_nl:
    "By placing an order, you agree to the <a href='https://nl.coral.club/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='https://nl.coral.club/faq/terms/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.",
  additional_info_term1_text_si:
    "By placing an order, you agree to the <a href='https://si.coral.club/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='https://si.coral.club/faq/terms/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.",
  additional_info_term1_text_hr:
    "By placing an order, you agree to the <a href='https://hr.coral.club/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='https://hr.coral.club/faq/terms/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.",
  additional_info_term1_text_se:
    "By placing an order, you agree to the <a href='https://se.coral.club/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='https://se.coral.club/faq/terms/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.",
  additional_info_term1_text_au:
    "By placing an order, you agree to the <a href='https://au.coral.club/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='https://au.coral.club/faq/terms/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.",
  additional_info_term1_text_me:
    "By placing an order, you agree to the <a href='https://me.coral.club/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='https://me.coral.club/faq/terms/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.",
  additional_info_term1_text_am:
    "By placing an order, you agree to the <a href='/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href=/faq/terms/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.    ",
  additional_info_term1_text_pt:
    "By placing an order, you agree to the <a href='/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='/faq/terms/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.",
  additional_info_term1_text_ca:
    "By placing an order, you agree to the <a href='/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a>.",
  additional_info_term1_text_fi:
    "By placing an order, you agree to the <a href='/faq/privacy/'  class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='/faq/terms/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.    ",
  additional_info_term1_text_md:
    "By placing an order, you agree to the <a href='/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='/faq/offer/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.    ",
  additional_info_term1_text_ag:
    "By placing an order, you agree to the <a href='/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='/faq/offer/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.    ",
  additional_info_term1_text_bb:
    "By placing an order, you agree to the <a href='/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='/faq/offer/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.    ",
  additional_info_term1_text_gd:
    "By placing an order, you agree to the <a href='/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='/faq/offer/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.    ",
  additional_info_term1_text_do:
    "By placing an order, you agree to the <a href='/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='/faq/offer/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.    ",
  additional_info_term1_text_jm:
    "By placing an order, you agree to the <a href='/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='/faq/offer/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.    ",
  additional_info_term1_text_bs:
    "By placing an order, you agree to the <a href='/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='/faq/offer/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.    ",
  additional_info_term1_text_ht:
    "By placing an order, you agree to the <a href='/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='/faq/offer/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.    ",
  additional_info_term1_text_dm:
    "By placing an order, you agree to the <a href='/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='/faq/offer/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.    ",
  additional_info_term1_text_tt:
    "By placing an order, you agree to the <a href='/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='/faq/offer/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.    ",
  additional_info_term1_text_no:
    "By placing an order, you agree to the <a href='/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='/faq/terms/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.",
  additional_info_term1_text_other:
    "By placing an order, you agree to the <a href='/faq/privacy/' class='text-accentColor font-medium' target='_blank'>Privacy Policy</a> and accept the <a href='/faq/offer/' class='text-accentColor font-medium' target='_blank'>Terms and Conditions</a>.",
  additional_info_de_term1_text: null,
  additional_info_de_term1_linktext: 'General conditions for trading',
  additional_info_de_term1_href: 'https://us.coral.club/faq/privacy/',
  additional_info_de_term2_text: 'I am familiar with',
  additional_info_de_term2_linktext: 'Terms of sale',
  additional_info_de_term2_href: 'https://us.coral.club/faq/terms/',
  unauth_have_acc: 'Do you already have an account?',
  unauth_login: 'Login',
  unauth_step1: "Enter your Consultant's Coral ID",
  unauth_step2: 'Buyer',
  unauth_step3: 'Delivery',
  unauth_step4: 'Payment',
  unauth_membership_text:
    'Enter the 7-digit Coral ID of your Consultant who referred you to Coral Club',
  unauth_nomember: 'Continue without a Consultant',
  unauth_yourmember: "Consultant's Coral ID",
  unauth_total: 'Total without registration',
  unauth_subbasket: 'Save 20% when you register',
  unauth_subbasket_reg: 'Register',
  unauth_freeship: 'Free Shipping Now',
  unauth_showMap: 'Select on map',
  unauth_hideMap: 'Hide Map',
  member_notfound: "Consultant's CCI ID was not found",
  member_wrongid: "Please review your consultant's CCI ID and try again",
  show_hidden_fields: "If you couldn't find your address, enter it manually",
  show_hidden_fields_button: 'Enter manually',
  checkout_hide_manual_address: 'Cancel manual address entry',
  default_profile: 'primary',
  NOTICE_BACK: 'Back',
  ORDER_NEXT: 'Next',
  ORDER_TAX: 'Cash on delivery service',
  ORDER_DELIVERY_PERIOD: 'Delivery time',
  CHECKOUT_TAX: 'Sales Tax',
  CONTACTS_SALE_OFFICES_ADDRESS: 'Address',
  piter_notification: '',
  kazan_1day_info: 'Доступно при заказе с 10 до 17',
  checkout_kz_time_notify:
    'The order delivery time has increased: we will transport the selected products from a warehouse in another city',
  workingDays_notify:
    'Working days: Monday - Friday, excluding holidays. Orders paid after 13:00 are processed on the next working day.',
  tooltip_name_de:
    'To receive an order, the name must appear on the doorbell and on the mailbox. Only for the list of countries listed at the end.',
  shipping_address_double_check: 'Shipping Address',
  CHECKOUT_ADDRESS_INFO_FIELDS_APARTMENT: 'ap. ',
  CHECKOUT_ADDRESS_INFO_FIELDS_KORPUS: 'bldg. ',
  CHECKOUT_ADDRESS_INFO_FIELDS_ENTRANCE: 'entrance ',
  CHECKOUT_ADDRESS_INFO_FIELDS_INTERCOM: 'ic. ',
  CHECKOUT_ADDRESS_INFO_FIELDS_FLOOR: 'floor',
  shipping_address_mask: 'Search',
  address_search_tooltip:
    'To use the search, start typing your address and select the desired option from the list provided.',
  ddp_title: 'Taxes and duties',
  ddp_howpay: 'How would you like to pay?',
  ddp_your_tax: 'Your fee',
  ddp_myself_title: 'I’ll handle it myself',
  ddp_myself_text: 'Place your order and return to pay taxes and charges later',
  ddp_ease_title: 'Pay now',
  ddp_ease_text: 'Pay all taxes and duties and save your time',
  AUTH__LOG_IN_CORAL_ID: 'Login with Coral ID',
  AUTH__GET_PASSWORD_TEXT: 'Do you have a club number but no account? ',
  AUTH__GET_PASSWORD: 'Create an account',
  AUTH__FORGOT_CORAL_ID: 'Forgot your Coral ID?',
  AUTH__FORGOT_CORAL_ID_TEXT:
    'If you have ordered previously but do not remember your club number, contact your Consultant or contact Customer Service.',
  FOOTER_TECH_SUPPORT: 'Support',
  HEADER_LOG_IN: 'Register/ Login',
  AUTH__TITLE: 'Login or <br> register now',
  AUTH__SUBTITLE: 'First time here?',
  AUTH__SUBTITLE2: 'Registration',
  AUTH__CORAL_ID: 'Your Coral ID',
  AUTH__PASSWORD: 'Password',
  AUTH__FORGOT: 'Forgot password?',
  AUTH__SIGN_IN: 'Sign in',
  AUTH__MORE: 'See more login options',
  TOMORROW: 'tomorrow',
  BASKET_BANNER_TITLE: '\nEnjoy the benefits of a Club Member',
  BASKET_BANNER_TEXT:
    '<a href="/registration/?BACK_URL=/basket/">Sign up</a> to get -20% on all orders, pay for purchases with bonuses and choose health products with a personal consultant.',
  PROFILES_LIST_OLD:
    'Unfortunately, we cannot automatically transfer profiles from a previous version. Find the desired address and confirm the data manually',
  PROFILES_OLD_PROFILE_REQUIRES_CONFIRMATION: 'Requires confirmation',
  PROFILES_OLD_PROFILE_DELETE: 'Delete',
  PROFILES_OLD_ADDRESSES: 'Old addresses',
  PROFILES_TRANSFER_ADDRESS: 'Transfer address',
  PROFILES_ADD_NEW_ADDRESS: 'Add new',
  PROFILES_NOT_FOUND_OLD_ADDRESS:
    'Didn’t find the needed address? Transfer from the previous checkout version',
  PROFILES_CITY_AREA_NOT_MATCH:
    'City or area does not match the delivery address. Please enter',
  forum_text: 'Get your order at Forum 2024 at Expo Krakow May 31-June 2',
  forum_address: 'Galicyjska 9, Cracow, Poland',
  city_change_error: 'You can’t change the city here',
  il_feemodal_more75: `
  <div class="flex flex-col gap-2">
    <b class="text-lg font-medium">Taxes and duties</b>
    <span>Your order over 250 ILS b and will be subject to additional duties.</span>
    <a href="#" target="_blank" class="color-accent">Read more</a>
  </div>
  `,
  il_feemodal_more1000:
    'The value of your order together with shipping cannot exceed 1000 USD (approximately 3500 ILS). Reduce the number of items.',
  il_feemodal_title: 'Customs Restrictions.',
  il_feemodal_button: 'I agree to pay for the tax and service!',
  kr_feemodal_title: 'Customs Restrictions.',
  kr_feemodal_button: 'There is a customs code. I agree to pay the fee',
  au_feemodal_title: 'Customs Restrictions.',
  au_feemodal_button: 'I agree to pay for the tax and service!',
  al_feemodal_title: 'Customs Restrictions.',
  al_feemodal_button: 'I agree to pay for the tax and service!',
  ao_feemodal_title: 'Customs Restrictions.',
  ao_feemodal_button: 'I agree to pay for the tax and service!',
  ad_feemodal_title: 'Customs Restrictions.',
  ad_feemodal_button: 'I agree to pay for the tax and service!',
  gb_feemodal_title: 'Customs Restrictions.',
  gb_feemodal_button: 'I agree to pay for the tax and service!',
  gy_feemodal_title: 'Customs Restrictions.',
  gy_feemodal_button: 'I agree to pay for the tax and service!',
  gm_feemodal_title: 'Customs Restrictions.',
  gm_feemodal_button: 'I agree to pay for the tax and service!',
  do_feemodal_title: 'Customs Restrictions.',
  do_feemodal_button: 'I agree to pay for the tax and service!',
  jo_feemodal_title: 'Customs Restrictions.',
  jo_feemodal_button: 'I agree to pay for the tax and service!',
  mg_feemodal_title: 'Customs Restrictions.',
  mg_feemodal_button: 'I agree to pay for the tax and service!',
  mk_feemodal_title: 'Customs Restrictions.',
  mk_feemodal_button: 'I agree to pay for the tax and service!',
  mz_feemodal_title: 'Customs Restrictions.',
  mz_feemodal_button: 'I agree to pay for the tax and service!',
  mc_feemodal_title: 'Customs Restrictions.',
  mc_feemodal_button: 'I agree to pay for the tax and service!',
  ne_feemodal_title: 'Customs Restrictions.',
  ne_feemodal_button: 'I agree to pay for the tax and service!',
  nz_feemodal_title: 'Customs Restrictions.',
  nz_feemodal_button: 'I agree to pay for the tax and service!',
  no_feemodal_title: 'Customs Restrictions.',
  no_feemodal_button: 'I agree to pay for the tax and service!',
  ae_feemodal_title: 'Customs Restrictions.',
  ae_feemodal_button: 'I agree to pay for the tax and service!',
  pa_feemodal_title: 'Customs Restrictions.',
  pa_feemodal_button: 'I agree to pay for the tax and service!',
  pg_feemodal_title: 'Customs Restrictions.',
  pg_feemodal_button: 'I agree to pay for the tax and service!',
  sm_feemodal_title: 'Customs Restrictions.',
  sm_feemodal_button: 'I agree to pay for the tax and service!',
  sa_feemodal_title: 'Customs Restrictions.',
  sa_feemodal_button: 'I agree to pay for the tax and service!',
  sn_feemodal_title: 'Customs Restrictions.',
  sn_feemodal_button: 'I agree to pay for the tax and service!',
  sg_feemodal_title: 'Customs Restrictions.',
  sg_feemodal_button: 'I agree to pay for the tax and service!',
  th_feemodal_title: 'Customs Restrictions.',
  th_feemodal_button: 'I agree to pay for the tax and service!',
  tw_feemodal_title: 'Customs Restrictions.',
  tw_feemodal_button: 'I agree to pay for the tax and service!',
  tg_feemodal_title: 'Customs Restrictions.',
  tg_feemodal_button: 'I agree to pay for the tax and service!',
  ph_feemodal_title: 'Customs Restrictions.',
  ph_feemodal_button: 'I agree to pay for the tax and service!',
  jm_feemodal_title: 'Customs Restrictions.',
  jm_feemodal_button: 'I agree to pay for the tax and service!',
  jp_feemodal_title: 'Customs Restrictions.',
  jp_feemodal_button: 'I agree to pay for the tax and service!',
  kg_feemodal_title: 'Customs Restrictions.',
  kg_feemodal_button: 'I agree to pay for the tax and service!',
  kz_feemodal_title: 'Customs Restrictions.',
  kz_feemodal_button: 'I agree to pay for the tax and service!',
  md_feemodal_title: 'Customs Restrictions.',
  md_feemodal_button: 'I agree to pay for the tax and service!',
  uz_feemodal_title: 'Customs Restrictions.',
  uz_feemodal_button: 'I agree to pay for the tax and service!',
  am_feemodal_title: 'Customs Restrictions.',
  am_feemodal_button: 'I agree to pay for the tax and service!',
  latin_only_russian_error: 'Use Latin letters',
  receiver_fio_placeholder: 'Trent John Alexander-Arnold',
  ORDER_FIELD_AUTOCOMPLETE_US: 'Address line 1',
  Character_limit_exceeded: 'Character limit exceeded',
  Character_minimum_required: 'Not enough characters',
  modal_delivery_no_available_title:
    'Delivery to the selected country is not available',
  modal_delivery_no_available_text_1: 'You place an order in ',
  modal_delivery_no_available_text_2:
    'but specified a delivery address in another country. Change the address or place an order on the website of the delivery country you need',
  phone_notification_spain:
    'Please, use the Spanish number (+34) so that the courier can contact you',
  erip_payment_number: 'Номер для оплаты в ЕРИП:',
  erip_order_amount: 'Сумма заказа:',
  erip_download_instructions: 'Скачать инструкцию по оплате',
  erip_pay_mobile_app: 'Оплатить в мобильном приложении банка',
  erip_check_order_status:
    'Проверьте статус оплаченного заказа или завершите оплату позже в Истории заказов',
  erip_order_history: 'Перейти в Историю заказов',
  erip_select_item:
    'Выберите пункт ЕРИП в интернет-банке, мобильном приложении или терминале.',
  erip_select_sequence: 'Выберите последовательно вкладки:',
  erip_goods: 'Товары',
  erip_works_services: 'Работы и услуги',
  erip_minsk: 'Минск',
  erip_vegafit: 'Вегафит',
  erip_enter_code: 'Введите код услуги:',
  erip_enter_order_number: 'Введите номер заказа для оплаты в ЕРИП:',
  erip_provide_fio: 'Укажите ФИО',
  erip_provide_order_amount: 'Укажите сумму заказа:',
  erip_check_correctness: 'Проверьте корректность введенной информации',
  erip_by_tree: 'По дереву ЕРИП',
  erip_by_service_code: 'По коду услуги ЕРИП',
  erip_scan_code:
    'Отсканируйте код и выберите мобильное приложение своего банка',
  cci_poland_notification_text:
    '<span>Cash on delivery payment terms have been changed. From now on, if you choose cash on delivery, the delivery cost will be PLN 18, regardless of the order amount.</span>',
  payment_notification_qatar:
    '<span>Not all bank cards in your region are connected to the payment service. If you have errors when paying by card, place your order using a bank transfer</span>',
  payment_notification_de_countries:
    '<span>After receiving payment via bank transfer (up to 5 business days), we will restore and transfer your order for delivery.</span>',
  ORDER_PROMO_CODE_TITLE: 'Promo code',
  i_pickup_get_order_notification:
    'You can pick up your order from the sales office immediately after placing it',
  REGISTRATION_CITY: 'City',
  onboarding_popup_point_one:
    'All information about the recipient, delivery and payment is on one screen and can be edited at any time',
  onboarding_popup_point_two:
    'Added the All Addresses button – select any of the saved addresses',
  onboarding_popup_point_three:
    'All delivery options are immediately visible - with prices and terms. Choose what is convenient for you',
  onboarding_popup_point_four:
    'Easily remove obsolete addresses with one click',
  onboarding_popup_point_five:
    "If you can't find the delivery city you need, use the advanced search.",
  onboarding_popup_action: "It's clear",
  faktura_title: 'Invoice',
  faktura_receive:
    'To receive an invoice with the correct data to the address you need, fill out the form',
  faktura_legal_entity: 'For a legal entity',
  faktura_same_address: 'Address and recipient as in delivery',
  ordering_process_changed: 'Changes have been made to the ordering process',
  BASKET_TRANSFER_POINTS: 'Transfer points',
  advanced_search_use_1: "If you haven't found your city, use",
  advanced_search_use_2: 'the advanced search',
  advanced_search_by_city_1: 'You are in advanced search mode, you can use',
  advanced_search_by_city_2: 'the city search',
  checkout_processing_data:
    "Даю согласие на <a href='/faq/personalinformation/' class='text-accentColor font-medium' target='_blank'>обработку персональных данных</a>",
  new_address_auto_save_info:
    'The new delivery address will be saved automatically after placing your order.',
  edit_address_auto_save_info:
    'Changes to the address and recipient details will be saved after placing the order.',
  DELIVERY_PROFILE_NOT_VALID:
    'The delivery method has changed — please review or choose another.',
  invoice_address: 'Address for invoice',
  name_email_checkout_duplicate_found_1: "Let's check your data!",
  name_email_checkout_duplicate_found_1_text:
    'To ensure we process your order correctly, please make sure you have entered all the information correctly.',
  name_email_checkout_duplicate_found_2: "Congratulations! You're now with us!",
  name_email_checkout_duplicate_found_2_text:
    "Great news – you're now a Coral Club Member! To continue shopping at club prices and view your full order history, simply log in to your account. Having trouble logging in? Our <a href='/support/list.php/' class='text-accentColor font-medium' target='_blank'>support team</a> is always here to help with any questions.",
  duplicate_modal_confirm_yes_btn: 'Yes, everything is correct.',
  duplicate_modal_confirm_no_btn: 'Correct data',
  duplicate_modal_auth_btn: 'Log in',
  post_address_subtitle:
    'We will send your order to the post office serving the specified address.',
  locality_check_title: 'Проверьте город доставки',
  locality_check_description:
    'Выбранный вами город {headerCity} не совпадает с городом {profileCity} в сохранённом адресе доставки. При смене города может измениться состав корзины',
  locality_check_header_city_btn: 'Выбранный город',
  locality_check_profile_city_btn: 'Сохранённый адрес',
  locality_unavailable_title: 'Некоторые продукты стали недоступны',
  locality_unavailable_description:
    'Вы изменили город доставки, поэтому теперь часть продуктов из корзины заказать не получится:',
  locality_unavailable_continue: 'Продолжить',
  locality_unavailable_check_basket: 'Проверить корзину',
  locality_unavailable_quantity_unit: 'шт',
  locality_empty_title: 'Не получится оформить заказ',
  locality_empty_description:
    'В выбранном городе доставки сейчас нет продуктов из вашей корзины. <br/> Перейдите в каталог, чтобы собрать новый заказ',
  locality_empty_go_catalog: 'Перейти в каталог',
  cyprus_notification:
    'Important: If you know a convenient ACS pickup location, please indicate it in the order comments. This way, we can forward your shipment directly to the selected ACS location.',
  cyprus_comment_label: 'Comment on the order',
  cyprus_comment_placeholder: 'ACS Item, Company Name, C/O, PO Box Number',
  ORDER_CONTENT_TEXT: 'Order contents',
  summary_add_more_products: 'Want to add more products?',
  promo_code_applied: 'applied!',
  promo_code_remove: 'Remove',
  promo_code_invalid: 'Invalid Promo Code',
  summary_product_single: 'product',
  summary_points_label: 'Points',
}
